import { connect } from 'react-redux';

import { siteboardAction } from '../actions/defaultActions';

import Schedule from './Schedule';

const FreeSchedule = ({_localEditScheduleId, _localEditScheduleProjectId, siteboardAction}) => {
  return (
    <div className='print:block print:w-full print:h-auto flex flex-col xl:flex-row w-screen h-screen overflow-hidden'>
      <Schedule projectId={_localEditScheduleProjectId} scheduleId={_localEditScheduleId} />
    </div>
  );
}

const mapStateToProps = state => { return { // define redux state that will be passed in as props
  _localEditScheduleId: state.serverSynced.localEditScheduleId,
  _localEditScheduleProjectId: state.serverSynced.localEditScheduleProjectId,
}};
export default connect(mapStateToProps, {siteboardAction})(FreeSchedule);
